import Vue from 'vue'
import App from './App.vue'
import router from '@/router/index.js'
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import '../theme/index.css';
import request from "@/utils/request";
Vue.prototype.request = request
import service from './components/service.vue'
Vue.component('service', service);
import goodsList from './components/goodsList.vue'
Vue.component('goodsList', goodsList);
import useList from './components/useList.vue'
Vue.component('useList', useList);
import order from './components/order.vue'
Vue.component('order', order);
import orderDetail from './components/orderDetail.vue'
Vue.component('orderDetail', orderDetail);
import identity from './components/identity.vue'
Vue.component('identity', identity);
import contact from './components/contact.vue'
Vue.component('contact', contact);
import  VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
Vue.config.productionTip = false
Vue.use(ElementUI)
router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
})
new Vue({
  render: h => h(App),
  router
}).$mount('#app')
